import { Navigate } from "react-router-dom";
import CollabDealView from "@/pages/deals/CollabDealView";
import { PUBLIC_ROUTES } from "@/routes/url";
import type { DealParticipation } from "@/types/authentication.types";

interface LenderOverviewProps {
  participation?: DealParticipation | null;
}

export default function LenderOverview({ participation }: LenderOverviewProps) {
  if (!participation?.deal_id) return <Navigate to={PUBLIC_ROUTES.LANDING} replace />;
  return <CollabDealView dealId={participation.deal_id} embedded />;
}
